import { render, staticRenderFns } from "./CardSendCommands.vue?vue&type=template&id=5996aca7&"
import script from "./CardSendCommands.vue?vue&type=script&lang=js&"
export * from "./CardSendCommands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports